__turbopack_context__.v({
  "root": "uamDAW_root",
});
